import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import { Helmet } from "react-helmet";
import { imagesList, imagesListNext, openModal } from "../../actions";
import Table from "../../components/Table";
import ImageListItem from "../../components/ImageListItem";
import NonIdealState from "../../components/NonIdealState";
import Pin from "../../components/Pin";
import ListImageToolbar from "./ListImageToolbar";
import qs from "qs";

const identity = (data) => data;

export class ListImagePage extends Component {
  constructor(props) {
    super(props);
    this.renderRow = this.renderRow.bind(this);
    this.onScroll = debounce(this.onScroll.bind(this), 300);
    this.onDelete = this.onDelete.bind(this);
    this.fetchMore = this.fetchMore.bind(this);
  }

  componentWillMount() {
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.props.imagesList(this.props.match.params.accountId, query, true);
    window.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onDelete(imageId) {
    this.props.openModal("delete-image", {
      id: imageId,
      accountId: this.props.match.params.accountId,
    });
  }

  fetchMore() {
    this.props.imagesListNext(this.props.match.params.accountId);
  }

  renderRow(email) {
    return (
      <ImageListItem
        email={email}
        key={email.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDelete}
      />
    );
  }

  renderFetching() {
    return <div>Fetching</div>;
  }

  onScroll(e) {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = window.innerHeight;
    const clientHeight = document.documentElement.scrollHeight || document.body.clientHeight;
    const threshold = clientHeight - 50;
    const scrollPosition = scrollTop + windowHeight;
    
    if (scrollPosition > threshold) {
      this.props.imagesListNext(this.props.match.params.accountId);
    }
  }

  render() {
    const { images, isFetching } = this.props;
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    return (
      <div>
        <Helmet>
          <title>{`Mercury - List Images`}</title>
        </Helmet>
        <Pin y={50}>
          <ListImageToolbar
            accountId={this.props.match.params.accountId}
            searchTerm={query.name}
          />
        </Pin>

        {images.length > 0 ? (
          <Table
            renderItem={this.renderRow}
            items={images}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : !isFetching ? (
          <NonIdealState title="No Images Found" visual="warning" />
        ) : (
          <NonIdealState title="Loading" visual="refresh" spin="true" />
        )}
      </div>
    );
  }
}

ListImagePage.propTypes = {
  imagesList: PropTypes.func.isRequired,
  imagesListNext: PropTypes.func.isRequired,
  images: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const imagesPagination = state.pagination.images || {};
  const images = (imagesPagination.ids || [])
    .map((id) => state.entities.image[id])
    .filter(identity);
  const isFetching = imagesPagination.isFetching;

  return {
    images,
    isFetching,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  imagesList,
  imagesListNext,
  openModal,
})(ListImagePage);
